/** @jsx  jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';

export const searchinputholder = css({
  [MediaQueries.sm]: {},
  [MediaQueries.md]: {},

  input: {
    paddingLeft: '0px',
    [MediaQueries.sm]: { fontSize: '34px !important' },
  },
  button: {
    borderRadius: '8px',
  },

  '.submitCss': {
    display: 'flex',
  },
});

export const searchFieldCss = css(typography.effra18, {
  border: 0,
  height: '100%',
  outline: 'none',
  padding: '10px 16px',
  width: '100%',
  '::-webkit-input-placeholder': {
    color: colorsPalette.grey80,
  },

  ':-ms-input-placeholder': {
    color: colorsPalette.grey80,
  },

  '::placeholder': {
    color: colorsPalette.grey80,
  },
});

export const NewSearch = css({
  color: '#000',
});

export const customDropdownLabelCss = css({
  border: 'none',
  borderRadius: 2,
  height: 68,
});

export const customContainerInputCss = css({
  border: 'none',
  borderRadius: 2,
  height: 68,
  marginBottom: 16,
  padding: 0,
  input: {
    borderBottom: '#4D4D4D solid 1px',
    backgroundColor: 'transparent',
    fontSize: '48px',
    lineHeight: '56px',
    letterSpacing: '-1px',
    textAlign: 'left',
    color: '#858585',
  },
  [MediaQueries.mdAndUp]: {
    marginBottom: 0,
  },
});

export const customContainerInputWithResultsCss = css({
  borderBottom: `1px solid ${colorsPalette.grey10}`,
});

export const formCss = css({
  width: '100%',

  '.formcont': {
    width: '100%',
    '.off0tab': {
      [MediaQueries.md]: {
        marginLeft: '0px',
      },
    },
    '.mobiconbtn': {
      [MediaQueries.sm]: {
        bottom: '25px',
        position: 'absolute',
        right: '6px',
      },
      [MediaQueries.md]: {
        // width: 'auto',
      },

      i: {
        fontSize: '20px',
      },

      '.submit_btn': {
        display: 'flex',
        minWidth: '144px',
        [MediaQueries.sm]: {
          display: 'none',
        },
        [MediaQueries.md]: {
          width: 'auto',
        },
      },

      '.searchmobicon': {
        display: 'none',
        [MediaQueries.sm]: {
          display: 'block',
          bottom: '32px',
          position: 'absolute',
          right: '0px',
        },
      },

      button: {
        [MediaQueries.sm]: {
          border: '0px',
          outline: 'none',
          background: 'transparent',
        },
      },
    },
  },
});

export const iconContainerCss = css({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyItems: 'center',
});

export const inputCss = css({
  marginBottom: 16,
  [MediaQueries.mdAndUp]: {
    marginBottom: 0,
  },
});

export const searchIconCss = css({
  color: colorsPalette.black,
  height: '100%',
  width: '100%',
});

export const searchResultItemCss = css(typography.effra18, {
  cursor: 'pointer',
  // display: 'block',
  display: 'flex',
  alignItems: 'baseline',
  padding: '16px 0 6px 4px',
  borderBottom: '1px solid #4D4D4D',
  '&:first-of-type': {
    paddingTop: 0,
  },
});

export const highlightedSearchResultItemCss = css({
  outline: `1px solid ${colorsPalette.teal}`,
});

export const searchResultsCss = css({
  background: 'transparent',
  borderBottomLeftRadius: 2,
  borderBottomRightRadius: 2,
  boxShadow: 'none',
  marginTop: 0,
  padding: '0px ',
  position: 'absolute',
  width: 'calc(100% - 24px)',
  zIndex: 1,
  [MediaQueries.mdAndUp]: {
    paddingTop: 25,
    width: 'calc(100% - 32px)',
  },
});

export const searchResultTextCss = css({
  marginLeft: 16,
  color: '#a2a2a2',
  [MediaQueries.lgAndUp]: {
    marginLeft: 20,
  },
});

export const submitCss = css({
  height: 68,
});

export const topOffsetSearchResultsCss = css({
  [MediaQueries.sm]: {
    top: -84,
  },
});

// DARK THEME 🧛‍♂️

export const darkCustomInputContainerCss = css({
  background: colorsPalette.black,
  color: colorsPalette.white,
  height: 75,
  marginBottom: 0,
  '&[data-focus="true"]': {
    border: 0,
    borderBottom: `1px solid ${colorsPalette.white}`,
    boxShadow: 'none',
  },
  [MediaQueries.lg]: {
    paddingRight: 0,
  },
});

export const darkCustomInputFieldCss = css(typography.effra58Input, {
  background: colorsPalette.black,
  caretColor: colorsPalette.grey50,
  color: colorsPalette.white,
  padding: '25px 16px 0 0',
  borderBottom: `1px solid ${colorsPalette.grey90}`,
  '&:focus': {
    borderBottom: `1px solid ${colorsPalette.grey50}`,
  },
  '::-webkit-input-placeholder': {
    color: colorsPalette.grey50,
  },

  ':-ms-input-placeholder': {
    color: colorsPalette.grey50,
  },

  '::placeholder': {
    color: colorsPalette.grey50,
  },
  [MediaQueries.mdAndUp]: {
    paddingBottom: 10,
  },
  [MediaQueries.xl]: {
    padding: '10px 0 17px',
  },
});

export const darkCustomDropdownLabelCss = css(typography.effra18, {
  alignItems: 'flex-end',
  background: colorsPalette.black,
  borderBottom: `1px solid ${colorsPalette.grey90}`,
  borderRadius: 0,
  color: colorsPalette.white,
  height: 70,
  padding: '25px 0 0',
  '&[data-focus="true"]': {
    border: 0,
    borderBottom: `1px solid ${colorsPalette.grey50}`,
  },
  [MediaQueries.mdAndUp]: {
    ...typography.effra28,
    alignItems: 'center',
    fontWeight: fontWeights.light,
    height: 75,
  },
  [MediaQueries.lgAndUp]: {
    ...typography.effra28,
    fontWeight: fontWeights.light,
  },
  [MediaQueries.xl]: {
    ...typography.effra34,
    fontWeight: fontWeights.light,
    paddingTop: 15,
  },
});

export const darkSelectContainerCss = css({
  maxWidth: 210,
  [MediaQueries.mdAndUp]: {
    maxWidth: 240,
  },
  [MediaQueries.lgAndUp]: {
    maxWidth: '100%',
  },
});

export const darkDropdownPlaceholderCss = css(typography.effra18, {
  color: colorsPalette.grey50,
  left: 0,
  top: 20,
  '&[data-shrink="true"]': {
    transform: 'translateY(-25%) scale(0.75)',
  },
  [MediaQueries.mdAndUp]: {
    ...typography.effra22,
    fontWeight: fontWeights.light,
    top: 20,
    '&[data-shrink="true"]': {
      transform: 'translateY(-40%) scale(0.80)',
    },
  },
  [MediaQueries.lgAndUp]: {
    top: 8,
    ...typography.effra28,
    fontWeight: fontWeights.light,
    '&[data-shrink="true"]': {
      transform: 'translateY(0) scale(0.55)',
    },
  },
  '&[data-focus="true"]': {
    color: colorsPalette.grey50,
  },
  [MediaQueries.xl]: {
    maxWidth: '100%',
    top: 0,
    '&[data-shrink="true"]': {
      transform: 'translateY(-5px) scale(0.55)',
    },
  },
});

export const darkIconCss = css({
  color: colorsPalette.white,
  right: 0,
  top: '75%',
  [MediaQueries.mdAndUp]: {
    top: '70%',
  },
  [MediaQueries.xl]: {
    top: '60%',
  },
});

export const darkIconContainerCss = css({
  // borderBottom: `1px solid ${colorsPalette.grey90}`,
});

export const darkSearchButtonColCss = css({
  bottom: 1,
  position: 'absolute',
  right: 0,
  [MediaQueries.lgAndUp]: {
    bottom: 'auto',
    position: 'relative',
    right: 'auto',
  },
});

export const darkSearchIconCss = css({
  background: colorsPalette.transparent,
  border: 0,
  color: colorsPalette.white,
  position: 'relative',
  '.icon-search': {
    bottom: 12,
    fontSize: 20,
    position: 'absolute',
    right: 0,
  },
  [MediaQueries.mdAndUp]: {
    '.icon-search': {
      bottom: 18,
    },
  },
});

export const darkSearchResultItemCss = css({
  borderBottom: `1px solid ${colorsPalette.grey90}`,
  '&:first-of-type': {
    paddingTop: 10,
  },
  '&:last-child': {
    borderBottom: `1px solid ${colorsPalette.grey90}`,
  },
});

export const darkSearchResultTextCss = css({
  color: colorsPalette.grey40,
});

export const darkSearchResultTextMatchCss = css({
  color: colorsPalette.white,
});

export const lightSearchResultTextMatchCss = css({
  color: '#E52500',
});

export const darkSearchResultsCss = css({
  background: colorsPalette.black,
  boxShadow: 'none',
  color: colorsPalette.white,
  padding: '27px 0 8px',
  [MediaQueries.mdAndUp]: {
    paddingTop: 7,
  },
  [MediaQueries.lgAndUp]: {
    paddingTop: 38,
  },
});

export const darkSubmitCss = css({
  bottom: -18,
  height: 56,
  position: 'relative',
});

export const darkSearchInputColCss = css({
  width: '100%',
  [MediaQueries.md]: {
    width: '100%',
  },
});

export const searchButtonLabelCss = css({
  transition: 'opacity 0.4s',
});

export const searchButtonLabelLoadingCss = css({
  opacity: 0,
});

export const searchAnimationCss = css({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

export const darkNoResultsCss = css({
  color: colorsPalette.white,
});

export const noResultsCss = css({
  border: 'none',
  color: colorsPalette.red120,
  marginTop: 16,
});

export const defaultNoResultsCss = css(typography.effra18, {
  alignItems: 'center',
  borderBottom: `1px solid ${colorsPalette.grey90}`,
  display: 'flex',
  marginTop: 48,
  paddingBottom: 2,
  position: 'absolute',
  width: 'calc(100% - 32px)',
});

export const iconErrorCss = css({
  alignItems: 'center',
  background: colorsPalette.white,
  borderRadius: '50%',
  color: colorsPalette.red120,
  display: 'flex',
  marginRight: 18,
});

export const suggestionItemIcomCust = css({
  width: 18,
});
